<template>
  <main class="main page-inside products-page categories-page">
    <div class="main-wrapper">
      <div class="section hero-section">
        <div class="wrapper">
          <div class="title regular light-green">
            Shop
          </div>
        </div>
        <img src="./../img/welcome2.png" class="img"/>
      </div>
      <div class="section categories-section">
        <div class="wrapper">
          <div class="desc desc-main normal montserrat">IN-GAME COSMETICS</div>
          <div class="desc desc-main normal montserrat sub">The product is exclusively in-game cosmetics and does not affect gameplay</div>
          <transition name="fade">
            <div class="list products" v-if="$parent.categories">
              <div class="item" v-for="(item, i) in $parent.categories" :key="i">
                <div class="item-wrapper">
                  <div class="preview">
                    <img :src="imgDomain  + item.image_url" class="img"/>
                  </div>
                  <button class="button" @click="$emit('chooseCategoty', item)">{{item.title}}</button>
                </div>
              </div>
            </div>
          </transition>
        </div>
      </div>
      <Social :social-links="$parent.socialLinks" />
    </div>
  </main>
</template>
<script>
import Social from '../components/Social.vue'

export default {
  name: 'Categories',
  props: [],
  components: {
    Social
  },
  data: function() {
    return {
      imgDomain: ''
    }
  },
  mounted() {
    this.imgDomain = process.env.VUE_APP_STATIC_DOMAIN;
  },
  methods: {
    
  }
}
</script>